import React, { useState, useEffect, useCallback } from 'react';
import {
    getPalletforceManifests, getPalletforceManifestByConsignment,
    getPalletforceTrackingByDate, getPalletforceTracking, getPodImages,
    syncPalletforceManifest, syncPalletforceTracking, getCustomerPaperwork,
    fetchCustomerPaperwork, getPallettrackManifests,
    getPallettrackManifestByConsignment, getPallettrackTrackingByDate,
    getPallettrackTracking, syncPallettrack, importPallettrackCsv,
    downloadPallettrackCsvTemplate, downloadPallettrackCsvGuide, getActivePallettrack,
    getPallettrackDeliveryMedia, getPallettrackPaperwork, uploadPallettrackPaperwork,
} from '../../api/integrations';
import KpiTab from './KpiTab';

const today = () => new Date().toISOString().slice(0, 10);

const SURCHARGE_LABELS = {
    AM:  'AM Delivery',
    BI:  'Book In',
    BW:  'Booked Window',
    EB:  'Economy Delivery',
    SA:  'Saturday AM',
    TA:  'By 10:00 AM',
    TB:  'Timed Booking',
    TL:  'Tail-Lift (collection & delivery)',
    PW:  'Paper POD Required',
    AZ:  'Amazon Book In',
    ETA: 'Request ETA',
};

const PALLETTRACK_SERVICE_LABELS = {
    EC: 'Economy',
    ND: 'Next Day',
    EP: 'Economy Pallet-Plus',
    NP: 'Next Day Pallet-Plus',
};

const PALLETTRACK_SURCHARGE_LABELS = {
    AM: 'AM Weekday', AZ: 'Amazon Booking', BI: 'Book In', CC: 'EU Customer Charges',
    EA: 'EU AM Delivery', EL: 'EU Tail Lift Delivery', EN: 'NES',
    EP: 'EU Pre-Booked Delivery', ES: 'EU Proof of Shipment', EX: 'EX1',
    FD: 'FORS Delivery', HD: 'Home Delivery', LF: 'Tail Lift Delivery Required',
    LQ: 'Limited Quantity', PB: 'Pre-Booked', PM: 'PM Weekday',
    PS: 'Premium Time Specific Delivery', PT: 'Premium Timed Delivery', SA: 'Saturday AM',
    SP: 'Saturday PM', ST: 'Saturday Timed', SZ: 'Amazon Saturday Booking',
    TI: 'Timed Delivery', TS: 'Time Specific', 10: 'Pre-10 Delivery', VR: 'Van Request',
};

const EVENT_CODE_LABELS = {
    ABRT:   'Delivery Aborted',
    AGRED:  'Agreed Out of Hours Delivery',
    ARDL:   'Arrived at Delivery Location',
    ARRD:   'Arrived at Delivery Depot',
    ARRH:   'Arrived At Hub',
    ARUK:   'Arrived at UK Depot',
    ARWET:  'Curtains Open Before Entering Hub - Wet Freight',
    BKLPOC: 'POC Received (Backload)',
    BKLPOD: 'POD Received (Backload)',
    CCC:    'Customs Clearance Confirmed',
    CODD:   'Change of Delivery Date',
    COUR:   'Courier Delivery',
    CREATED:'Consignment Accepted',
    CSTF:   'Custom Fees',
    DAM:    'Depot Received Damaged',
    DBAY:   'Damaged In Bay',
    DDAMB:  'Damaged - Pallet Base',
    DDAMG:  'Damaged - Goods',
    DDAMI:  'Damaged - Items Missing',
    DDAMP:  'Damaged Packaging',
    DELV:   'Scanned on Delivery Vehicle',
    DEPH:   'Left Hub for Depot',
    DEPW:   'Depot Warehouse Check',
    DIMAD:  'Incorrect Manifest - Wrong Address',
    DIMHZ:  'Incorrect Manifest - Hazardous',
    DIMPQ:  'Incorrect Manifest - Pallet Quantities',
    DIMPT:  'Incorrect Manifest - Pallet Types',
    DIMSU:  'Incorrect Manifest - Surcharge',
    DIMSV:  'Incorrect Manifest - Service',
    DIMWT:  'Incorrect Manifest - Weight',
    DIS:    'Depot Scan Discrepancy',
    DISC:   'Discrepancy',
    DMGD:   'Delivered Damaged',
    DNRNA:  'Not Received - Not Held Over',
    DNRNS:  'Not Received - No Scans',
    DNROH:  'Not Received - Held Over',
    DONR:   'En Route to Delivery Location',
    DPPE:   'Delivered - POD Pending (Europe)',
    DPUK:   'Departed UK Depot',
    DSDH:   'Depot Holding Route',
    EXCC:   'Customs Cleared',
    EXCL:   'Export Customs Cleared',
    EXIS:   'Existing Load',
    FAILC:  'Delivery Failed Due to Consignee',
    FAILD:  'Delivery Failed Due to Delivery Depot',
    FAILR:  'Delivery Failed Due to Requesting Depot',
    GEN:    'General Depot Scan (Legacy)',
    HINH:   'Held In Hub',
    HLTIN:  'Late Held Freight',
    HUBD:   'Hub Damaged',
    HWET:   'Freight Received Wet at Hub',
    IECC:   'Import/Export Customs Cleared',
    LABL:   'Heppner Re-Label',
    MISC:   'Other',
    NCCO:   'Not Collected - Cancelled Order',
    NCCR:   'Not Collected - Premises Closed/Nobody on Site',
    NCD:    'Not Collected - Duplication/Already Collected',
    NCIW:   'Not Collected - Incorrect Weight',
    NCNR:   'Not Collected - Goods Not Ready/Loading Delays',
    NCR:    'Not Collected - No Ref/End Destination Provided',
    NTC:    'Nothing to Collect',
    OVSZ:   'Oversize',
    PCC:    'Pending Customs Clearance',
    PFF:    'Palletforce Failed',
    POC:    'Consignment Collected',
    POD:    'POD Received',
    PODD:   'POD Received - Consignment Damaged',
    PODE:   'POD Received with Exception',
    PREF:   'Refused at Delivery Point',
    RECD:   'Received Damaged',
    REDC:   'Re-delivery Due to Consignee',
    REDD:   'Re-delivery Due to Delivery Depot',
    REDL:   'Re-delivery',
    REDR:   'Re-delivery Due to Requesting Depot',
    REF:    'Refused at Delivery Point',
    REFD:   'Refused Damaged',
    REFH:   'Refused at Hub',
    REFO:   'Refused Oversize',
    REPD:   'Received - Possible Damage',
    RETS:   'Return Pallets to Sender',
    SCDO:   'Scanned onto Day 1 Sort Trunk',
    SCDV:   'Scanned onto Delivery Vehicle',
    SCIT:   'Scanned on International Trunk',
    SCOT:   'Scanned on Trunk',
    SERR:   'Status Code Not Recognised',
    SRID:   'Scanned Off Collection & Delivery Vehicle',
    THS:    'Transited Hub',
    THSEU:  'Pallet Scanned Through EU Hub',
    TID:    'Taken in Day',
    UC:     'Unknown Collection Status',
    WAIT:   'Waiting Time',
    WAITC:  'Waiting Time due to Consignee',
    WAITD:  'Waiting Time due to Delivery Depot',
    WAITR:  'Waiting Time due to Requesting Depot',
};

export default function PaletforcePage({ theme = 'light', showAlert, integrationId, provider = 'palletforce' }) {
    const isDark = theme === 'dark';
    const isPallettrack = provider === 'pallettrack';
    const surchargeLabels = isPallettrack ? PALLETTRACK_SURCHARGE_LABELS : SURCHARGE_LABELS;
    const loadManifestsApi = isPallettrack ? getPallettrackManifests : getPalletforceManifests;
    const loadManifestApi = isPallettrack ? getPallettrackManifestByConsignment : getPalletforceManifestByConsignment;
    const loadTrackingByDateApi = isPallettrack ? getPallettrackTrackingByDate : getPalletforceTrackingByDate;
    const loadTrackingApi = isPallettrack ? getPallettrackTracking : getPalletforceTracking;

    // Stable ref for showAlert — prevents useCallback deps from changing on every parent re-render
    const showAlertRef = React.useRef(showAlert);
    React.useEffect(() => { showAlertRef.current = showAlert; }, [showAlert]);
    const alert = (opts) => showAlertRef.current && showAlertRef.current(opts);

    const c = {
        bg:      isDark ? '#1a1a1a' : '#fff',
        fg:      isDark ? '#e0e0e0' : '#333',
        border:  isDark ? '#444' : '#dee2e6',
        cardBg:  isDark ? '#2d2d2d' : '#f8f9fa',
        headerBg:isDark ? '#252525' : '#e9ecef',
        active:  'rgba(25,151,235,0.85)',
        muted:   isDark ? '#aaa' : '#666',
        hover:   isDark ? '#383838' : '#f0f4ff',
    };

    const [activeView, setActiveView] = useState('manifests');
    const [csvFile, setCsvFile] = useState(null);
    const [isUploadingCsv, setIsUploadingCsv] = useState(false);
    const [csvResult, setCsvResult] = useState(null);
    const [pallettrackIntegrationId, setPallettrackIntegrationId] = useState(null);
    const effectiveIntegrationId = isPallettrack ? pallettrackIntegrationId : integrationId;

    useEffect(() => {
        if (!isPallettrack) return;
        getActivePallettrack().then(response => {
            if (response.ok) setPallettrackIntegrationId(response.data?.integration?.id || null);
        });
    }, [isPallettrack]);

    // ── Manifests ────────────────────────────────────────────────────────────
    const [selectedDate, setSelectedDate] = useState(today());
    const [manifests, setManifests] = useState([]);
    const [isLoadingManifests, setIsLoadingManifests] = useState(false);
    const [isSyncingManifest, setIsSyncingManifest] = useState(false);
    const [expandedRow, setExpandedRow] = useState(null);
    const [manifestSortDir, setManifestSortDir] = useState(null); // null | 'asc' | 'desc'

    const loadManifests = useCallback(async (date) => {
        setIsLoadingManifests(true);
        setExpandedRow(null);
        try {
            const res = await loadManifestsApi(date);
            if (!res.ok) throw new Error(res.data?.error || `HTTP ${res.status}`);
            setManifests(res.data?.manifests ?? []);
        } catch (e) {
            alert({ message: 'Failed to load manifests: ' + e.message, type: 'danger', buttons: [{ label: 'Close' }] });
        } finally {
            setIsLoadingManifests(false);
        }
    }, [loadManifestsApi]);

    useEffect(() => {
        if (activeView === 'manifests') loadManifests(selectedDate);
    }, [activeView, selectedDate, loadManifests]);

    // ── Tracking ─────────────────────────────────────────────────────────────
    const [trackingDate, setTrackingDate] = useState(today());
    const [trackingEvents, setTrackingEvents] = useState([]);
    const [isLoadingTracking, setIsLoadingTracking] = useState(false);
    const [isSyncingTracking, setIsSyncingTracking] = useState(false);
    const [cnSearchInput, setCnSearchInput] = useState('');
    const [podState, setPodState] = useState({}); // { [trackingCode]: { images, loading } }
    const [paperworkState, setPaperworkState] = useState({}); // { [cn]: { items, loading } }
    const [modalCn, setModalCn] = useState(null);             // currently open consignment modal
    const [modalEvents, setModalEvents] = useState([]);        // all DB events for modalCn
    const [isLoadingModalEvents, setIsLoadingModalEvents] = useState(false);
    const [expandedManifestData, setExpandedManifestData] = useState({}); // { [cn]: { manifest, loading } }
    const [isUploadingPaperwork, setIsUploadingPaperwork] = useState(false);
    const paperworkInputRef = React.useRef(null);

    const loadTrackingForDate = useCallback(async (date) => {
        setIsLoadingTracking(true);
        setTrackingEvents([]);
        try {
            const res = await loadTrackingByDateApi(date);
            if (!res.ok) throw new Error(res.data?.error || `HTTP ${res.status}`);
            setTrackingEvents(res.data?.events ?? []);
        } catch (e) {
            alert({ message: 'Failed to load tracking: ' + e.message, type: 'danger', buttons: [{ label: 'Close' }] });
        } finally {
            setIsLoadingTracking(false);
        }
    }, [loadTrackingByDateApi]);

    useEffect(() => {
        if (activeView === 'tracking') loadTrackingForDate(trackingDate);
    }, [activeView, trackingDate, loadTrackingForDate]);

    // One row per consignment — latest event wins. Hoisted here so it isn't
    // recreated on every render (avoids focus loss in the search input).
    const consignmentRows = React.useMemo(() => {
        const map = new Map();
        for (const ev of trackingEvents) {
            const cn = ev.consignment_number;
            if (!cn) continue;
            const existing = map.get(cn);
            if (!existing || new Date(ev.event_datetime) > new Date(existing.event_datetime)) {
                map.set(cn, ev);
            }
        }
        return Array.from(map.values()).sort(
            (a, b) => new Date(b.event_datetime) - new Date(a.event_datetime)
        );
    }, [trackingEvents]);

    // When modal opens, load full event history + manifest details + POD images
    useEffect(() => {
        if (modalCn) {
            setIsLoadingModalEvents(true);
            loadTrackingApi(modalCn)
                .then(res => setModalEvents(res.data?.events ?? []))
                .catch(() => setModalEvents([]))
                .finally(() => setIsLoadingModalEvents(false));
            if (!expandedManifestData[modalCn]) handleLoadManifest(modalCn);
            if (isPallettrack) {
                handleLoadPallettrackPaperwork(modalCn);
                handleLoadPallettrackMedia(modalCn);
            } else if (!podState[modalCn]) {
                handleLoadPod(modalCn);
            }
        } else {
            setModalEvents([]);
        }
    }, [modalCn]); // eslint-disable-line react-hooks/exhaustive-deps

    // Load POD images: DB-first → Palletforce fallback → save → display (GET endpoint handles all of this)
    const handleLoadPod = async (cn) => {
        setPodState(prev => ({ ...prev, [cn]: { images: prev[cn]?.images ?? [], loading: true, fetchErrors: null } }));
        try {
            const res = await getPodImages(integrationId, cn);
            const fetchErrors = res.data?.fetch_errors ?? null;
            setPodState(prev => ({ ...prev, [cn]: { images: res.data?.images ?? [], loading: false, fetchErrors } }));
        } catch (e) {
            alert({ message: 'Failed to load images: ' + e.message, type: 'danger', buttons: [{ label: 'Close' }] });
            setPodState(prev => ({ ...prev, [cn]: { images: prev[cn]?.images ?? [], loading: false, fetchErrors: null } }));
        }
    };

    // Force a fresh load by clearing the cache first, then running the DB-first flow
    const handleRefreshPod = (cn) => {
        setPodState(prev => ({ ...prev, [cn]: undefined }));
        // useEffect will re-fire because podState[cn] is now falsy
        handleLoadPod(cn);
    };

    // Check DB for paperwork first; if none found, call Palletforce; if still none, alert
    const handleCheckPaperwork = async (cn) => {
        setPaperworkState(prev => ({ ...prev, [cn]: { items: prev[cn]?.items ?? [], loading: true } }));
        try {
            // Step 1: check DB
            const dbRes = await getCustomerPaperwork(integrationId, cn);
            const dbItems = dbRes.data?.paperwork ?? [];
            if (dbItems.length > 0) {
                setPaperworkState(prev => ({ ...prev, [cn]: { items: dbItems, loading: false } }));
                return;
            }
            // Step 2: fetch from Palletforce
            const pfRes = await fetchCustomerPaperwork(integrationId, cn);
            const pfItems = pfRes.data?.paperwork ?? [];
            if (pfItems.length > 0) {
                setPaperworkState(prev => ({ ...prev, [cn]: { items: pfItems, loading: false } }));
                return;
            }
            // Step 3: nothing found
            setPaperworkState(prev => ({ ...prev, [cn]: { items: [], loading: false } }));
            showAlert({ message: 'No paperwork found for this consignment.', type: 'warning', buttons: [{ label: 'OK' }] });
        } catch (e) {
            setPaperworkState(prev => ({ ...prev, [cn]: { items: prev[cn]?.items ?? [], loading: false } }));
            showAlert({ message: 'Failed to check paperwork: ' + e.message, type: 'danger', buttons: [{ label: 'Close' }] });
        }
    };

    const handleLoadPallettrackPaperwork = async (cn) => {
        setPaperworkState(prev => ({ ...prev, [cn]: { items: prev[cn]?.items ?? [], loading: true } }));
        try {
            const res = await getPallettrackPaperwork(cn);
            if (!res.ok) throw new Error(res.data?.error || `HTTP ${res.status}`);
            setPaperworkState(prev => ({ ...prev, [cn]: { items: res.data?.paperwork ?? [], loading: false } }));
        } catch (e) {
            setPaperworkState(prev => ({ ...prev, [cn]: { items: [], loading: false } }));
            alert({ message: 'Failed to load uploaded paperwork: ' + e.message, type: 'danger', buttons: [{ label: 'Close' }] });
        }
    };

    const handleLoadPallettrackMedia = async (cn) => {
        setPodState(prev => ({ ...prev, [cn]: { images: prev[cn]?.images ?? [], loading: true, fetchErrors: null } }));
        try {
            const res = await getPallettrackDeliveryMedia(cn);
            if (!res.ok) throw new Error(res.data?.error || `HTTP ${res.status}`);
            setPodState(prev => ({
                ...prev,
                [cn]: {
                    images: res.data?.images ?? [],
                    loading: false,
                    fetchErrors: res.data?.fetch_errors ?? null,
                },
            }));
        } catch (e) {
            setPodState(prev => ({ ...prev, [cn]: { images: prev[cn]?.images ?? [], loading: false, fetchErrors: [e.message] } }));
            alert({ message: 'Failed to check PalletTrack delivery media: ' + e.message, type: 'danger', buttons: [{ label: 'Close' }] });
        }
    };

    const handleUploadPaperwork = async (event) => {
        const file = event.target.files?.[0];
        event.target.value = '';
        if (!file || !modalCn) return;
        setIsUploadingPaperwork(true);
        try {
            const res = await uploadPallettrackPaperwork(modalCn, file);
            if (!res.ok) throw new Error(res.data?.error || `HTTP ${res.status}`);
            await handleLoadPallettrackPaperwork(modalCn);
            alert({
                message: res.data?.warning || `${file.name} was uploaded to PalletTrack and is now available here.`,
                type: res.data?.warning ? 'warning' : 'success',
                buttons: [{ label: 'OK' }],
            });
        } catch (e) {
            alert({ message: 'Failed to upload paperwork: ' + e.message, type: 'danger', buttons: [{ label: 'Close' }] });
        } finally {
            setIsUploadingPaperwork(false);
        }
    };

    const handleLoadManifest = async (cn) => {
        setExpandedManifestData(prev => ({ ...prev, [cn]: { manifest: null, loading: true } }));
        try {
            const res = await loadManifestApi(cn);
            setExpandedManifestData(prev => ({ ...prev, [cn]: { manifest: res.data?.manifest ?? null, loading: false } }));
        } catch {
            setExpandedManifestData(prev => ({ ...prev, [cn]: { manifest: null, loading: false } }));
        }
    };

    // ── Styles ───────────────────────────────────────────────────────────────
    const s = {
        wrap:    { display: 'flex', height: '100%', minHeight: '500px', color: c.fg, background: c.bg },
        nav:     { width: '160px', minWidth: '160px', borderRight: `1px solid ${c.border}`, paddingTop: '12px', background: c.cardBg },
        navItem: (active) => ({
            padding: '10px 14px', cursor: 'pointer', fontSize: '14px',
            background: active ? c.active : 'transparent',
            color: active ? '#fff' : c.fg,
            borderLeft: active ? '3px solid #1997eb' : '3px solid transparent',
        }),
        content:     { flex: 1, padding: '18px', overflowY: 'auto' },
        table:       { width: '100%', borderCollapse: 'collapse', fontSize: '13px' },
        th:          { background: c.headerBg, padding: '8px 10px', textAlign: 'left', border: `1px solid ${c.border}`, fontWeight: 600 },
        td:          { padding: '7px 10px', border: `1px solid ${c.border}`, verticalAlign: 'top' },
        badge:       (color) => ({ background: color, color: '#fff', borderRadius: '3px', padding: '2px 7px', fontSize: '11px', whiteSpace: 'nowrap' }),
        input:       { background: c.bg, color: c.fg, border: `1px solid ${c.border}`, borderRadius: '4px', padding: '6px 10px', fontSize: '13px' },
        btn:         (variant) => ({
            background: variant === 'primary' ? '#1997eb' : variant === 'danger' ? '#dc3545' : c.cardBg,
            color: ['primary','danger'].includes(variant) ? '#fff' : c.fg,
            border: `1px solid ${c.border}`, borderRadius: '4px', padding: '6px 14px',
            cursor: 'pointer', fontSize: '13px',
        }),
        expandedBg:  { background: c.cardBg, padding: '12px 16px', borderBottom: `1px solid ${c.border}` },
        label:       { fontWeight: 600, marginRight: '6px', color: c.muted },
    };

    // ── Render helpers ───────────────────────────────────────────────────────
    const fmtDate = (v) => v ? v.slice(0, 10) : '—';
    const fmtDT      = (v) => v ? v.replace('T', ' ').slice(0, 19) : '—';
    // Format HHMM → HH:MM (used for timed booking windows from SSCT/ESCT)
    const fmtHHMM = (v) => v && v.length >= 4 ? `${v.slice(0, 2)}:${v.slice(2, 4)}` : (v || null);
    const fmtBookingTime = (from, to, rawData) => {
        const f = from || rawData?.datesAndTimes?.find(d => d.dateTimeType === 'SSCT')?.value;
        const t = to   || rawData?.datesAndTimes?.find(d => d.dateTimeType === 'ESCT')?.value;
        if (!f && !t) return null;
        return `${fmtHHMM(f) || '?'} – ${fmtHHMM(t) || '?'}`;
    };
    const fmtDTLocal  = (v) => {
        if (!v) return '—';
        const d = new Date(v);
        return isNaN(d) ? fmtDT(v) : d.toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    };

    const DetailRow = ({ label, value }) => (
        <div style={{ marginBottom: '4px' }}>
            <span style={s.label}>{label}:</span>
            <span>{value || '—'}</span>
        </div>
    );

    // ── Palletforce raw_data helpers ─────────────────────────────────────────
    const palletCount = (m, type) => {
        const colMap = { F: 'pallets_full', H: 'pallets_half', Q: 'pallets_quarter', O: 'pallets_oversize' };
        const col = colMap[type];
        if (col && m[col] != null) return m[col];
        // fallback to raw_data for rows synced before the column migration
        const p = (m.raw_data?.pallets || []).find(pt => pt.palletType === type);
        return parseInt(p?.numberofPallets || '0', 10) || 0;
    };
    const palletSpaces = (m) => (
        m.pallet_spaces
        ?? m.raw_data?.palletSpaces
        ?? m.raw_data?.GoodsDefinition?.TotalSpaces
        ?? m.raw_data?.goodsDefinition?.totalSpaces
    );
    const getSurchargeColour = (code) => ({
        AM: '#fd7e14', SA: '#fd7e14', TA: '#fd7e14', TB: '#fd7e14', BW: '#fd7e14',
        TL: '#dc3545', BI: '#6f42c1', ETA: '#17a2b8', EB: '#20c997', PW: '#6c757d', AZ: '#ff9900',
    }[code] || '#6c757d');

    // ── Manifests view ───────────────────────────────────────────────────────
    const ManifestsView = () => (
        <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px', flexWrap: 'wrap' }}>
                <h5 style={{ margin: 0 }}>Manifests</h5>
                <input
                    type="date"
                    value={selectedDate}
                    onChange={e => setSelectedDate(e.target.value)}
                    style={s.input}
                />
                <button style={s.btn('primary')} onClick={() => loadManifests(selectedDate)}>
                    Refresh
                </button>
                <button
                    style={{ ...s.btn('default'), fontSize: '12px' }}
                    onClick={async () => {
                        setIsSyncingManifest(true);
                        try {
                            const res = isPallettrack ? await syncPallettrack() : await syncPalletforceManifest(integrationId);
                            if (!res.ok) throw new Error(res.data?.error || `HTTP ${res.status}`);
                            if (res.data?.status === 'skipped') {
                                alert({ message: res.data.message, type: 'warning', buttons: [{ label: 'Close' }] });
                            } else {
                                alert({ message: `Manifest sync complete — ${res.data?.records_synced ?? 0} records updated`, type: 'success', buttons: [{ label: 'Close' }] });
                            }
                            loadManifests(selectedDate);
                        } catch (e) {
                            alert({ message: 'Sync failed: ' + e.message, type: 'danger', buttons: [{ label: 'Close' }] });
                        } finally {
                            setIsSyncingManifest(false);
                        }
                    }}
                    disabled={isSyncingManifest}
                >
                    {isSyncingManifest ? 'Syncing…' : '↻ Sync Manifest'}
                </button>
                <span style={{ color: c.muted, fontSize: '12px' }}>
                    {isLoadingManifests ? 'Loading…' : `${manifests.length} consignment${manifests.length !== 1 ? 's' : ''}`}
                </span>
            </div>

            {isLoadingManifests ? (
                <div style={{ textAlign: 'center', padding: '40px', color: c.muted }}>Loading manifests…</div>
            ) : manifests.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '40px', color: c.muted }}>No manifests for {selectedDate}</div>
            ) : (
                <table style={s.table}>
                    <thead>
                        <tr>
                            {['Consignment No','Delivery Name','Postcode','F','H','Q','O','Spaces','Weight','Service','Surcharges','Del. Depot','Collection','Delivery'].map(h => (
                                h === 'Consignment No'
                                    ? <th key={h} style={{ ...s.th, cursor: 'pointer', userSelect: 'none' }} onClick={() => setManifestSortDir(d => d === 'asc' ? 'desc' : 'asc')}>
                                        {h} {manifestSortDir === 'asc' ? '▲' : manifestSortDir === 'desc' ? '▼' : '⇅'}
                                      </th>
                                    : <th key={h} style={s.th}>{h}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {[...manifests].sort((a, b) => {
                            if (!manifestSortDir) return 0;
                            const ca = (a.consignment_number || '').toLowerCase();
                            const cb = (b.consignment_number || '').toLowerCase();
                            return manifestSortDir === 'asc' ? ca.localeCompare(cb) : cb.localeCompare(ca);
                        }).map((m, i) => {
                            const isExpanded = expandedRow === m.id || expandedRow === i;
                            return (
                                <React.Fragment key={m.id ?? i}>
                                    <tr
                                        style={{ cursor: 'pointer', background: isExpanded ? c.hover : (i % 2 === 0 ? 'transparent' : c.cardBg) }}
                                        onClick={() => setExpandedRow(isExpanded ? null : (m.id ?? i))}
                                    >
                                        <td style={s.td}>
                                            <span style={{ color: '#1997eb', fontWeight: 600 }}>{m.consignment_number || '—'}</span>
                                        </td>
                                        <td style={s.td}>{m.delivery_name || '—'}</td>
                                        <td style={s.td}>{m.delivery_postcode || '—'}</td>
                                        <td style={{ ...s.td, textAlign: 'center' }}>{palletCount(m, 'F') || ''}</td>
                                        <td style={{ ...s.td, textAlign: 'center' }}>{palletCount(m, 'H') || ''}</td>
                                        <td style={{ ...s.td, textAlign: 'center' }}>{palletCount(m, 'Q') || ''}</td>
                                        <td style={{ ...s.td, textAlign: 'center' }}>{palletCount(m, 'O') || ''}</td>
                                        <td style={{ ...s.td, textAlign: 'center' }}>{palletSpaces(m) ?? ''}</td>
                                        <td style={s.td}>{m.weight ? `${m.weight} kg` : '—'}</td>
                                        <td style={s.td}>
                                            {m.service_code ? <span title={isPallettrack ? (PALLETTRACK_SERVICE_LABELS[m.service_code] || m.service_code) : m.service_code} style={s.badge(m.service_code === 'A' ? '#28a745' : m.service_code === 'B' ? '#1997eb' : '#ffc107')}>{m.service_code}</span> : '—'}
                                        </td>
                                        <td style={s.td}>
                                            {(m.surcharges || m.raw_data?.surcharges)
                                                ? (m.surcharges || m.raw_data.surcharges).split(' ').filter(Boolean).map(code => (
                                                    <span key={code} title={surchargeLabels[code] || code} style={{ ...s.badge(getSurchargeColour(code)), marginRight: '3px', fontSize: '11px' }}>{code}</span>
                                                ))
                                                : '—'}
                                        </td>
                                        <td style={{ ...s.td, textAlign: 'center' }}>{m.delivery_depot || m.raw_data?.deliveryDepot || '—'}</td>
                                        <td style={s.td}>{fmtDate(m.collection_date)}</td>
                                        <td style={s.td}>{fmtDate(m.delivery_date)}</td>
                                    </tr>
                                    {isExpanded && (
                                        <tr>
                                            <td colSpan={14} style={{ padding: 0, border: `1px solid ${c.border}` }}>
                                                <div style={s.expandedBg}>
                                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px,1fr))', gap: '8px 24px' }}>
                                                        <DetailRow label="Consignment No" value={m.consignment_number} />
                                                        <DetailRow label="Customer Account" value={m.customer_account_number} />
                                                        <DetailRow label="Customer Reference" value={m.customer_reference} />
                                                        <DetailRow label="Service Level" value={m.service_level} />
                                                        <DetailRow label="Pallets (total)" value={m.number_of_pallets} />
                                                        <DetailRow label="Full (F)" value={palletCount(m, 'F')} />
                                                        <DetailRow label="Half (H)" value={palletCount(m, 'H')} />
                                                        <DetailRow label="Quarter (Q)" value={palletCount(m, 'Q')} />
                                                        <DetailRow label="Oversize (O)" value={palletCount(m, 'O')} />
                                                        <DetailRow label="Pallet Spaces" value={palletSpaces(m)} />
                                                        <DetailRow label="Delivery Depot" value={m.delivery_depot || m.raw_data?.deliveryDepot} />
                                                        <DetailRow label="Collecting Depot" value={m.collecting_depot || m.raw_data?.collectingDepot} />
                                                        <DetailRow label="Surcharges" value={m.surcharges || m.raw_data?.surcharges} />
                                                        <DetailRow label="Weight (kg)" value={m.weight} />
                                                        <DetailRow label="Collection Date" value={fmtDate(m.collection_date)} />
                                                        <DetailRow label="Delivery Date" value={fmtDate(m.delivery_date)} />
                                                        {fmtBookingTime(m.booking_time_from, m.booking_time_to, m.raw_data) && (
                                                            <DetailRow label="Booking Window" value={fmtBookingTime(m.booking_time_from, m.booking_time_to, m.raw_data)} />
                                                        )}
                                                        <DetailRow label="Synced" value={fmtDTLocal(m.synced_at)} />
                                                        <div style={{ gridColumn: '1 / -1', borderTop: `1px solid ${c.border}`, marginTop: '4px', paddingTop: '8px', fontWeight: 600 }}>
                                                            Delivery Address
                                                        </div>
                                                        <DetailRow label="Name" value={m.delivery_name} />
                                                        <DetailRow label="Address 1" value={m.delivery_address1} />
                                                        <DetailRow label="Address 2" value={m.delivery_address2} />
                                                        <DetailRow label="City" value={m.delivery_town} />
                                                        <DetailRow label="County" value={m.delivery_county} />
                                                        <DetailRow label="Postcode" value={m.delivery_postcode} />
                                                        <DetailRow label="Country" value={m.delivery_country} />
                                                        {m.special_instructions && (
                                                            <div style={{ gridColumn: '1 / -1' }}>
                                                                <span style={s.label}>Special Instructions:</span>
                                                                <span style={{ color: '#ffc107' }}>{m.special_instructions}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div style={{ marginTop: '10px' }}>
                                                        <button
                                                            style={{ ...s.btn('primary'), fontSize: '12px' }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setActiveView('tracking');
                                                                setModalCn(m.consignment_number);
                                                            }}
                                                        >
                                                            View Tracking →
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                    <tfoot>
                        <tr style={{ background: c.headerBg, fontWeight: 700 }}>
                            <td style={{ ...s.td, fontWeight: 700 }} colSpan={3}>Totals</td>
                            <td style={{ ...s.td, textAlign: 'center', fontWeight: 700 }}>{manifests.reduce((a, m) => a + (palletCount(m, 'F') || 0), 0) || ''}</td>
                            <td style={{ ...s.td, textAlign: 'center', fontWeight: 700 }}>{manifests.reduce((a, m) => a + (palletCount(m, 'H') || 0), 0) || ''}</td>
                            <td style={{ ...s.td, textAlign: 'center', fontWeight: 700 }}>{manifests.reduce((a, m) => a + (palletCount(m, 'Q') || 0), 0) || ''}</td>
                            <td style={{ ...s.td, textAlign: 'center', fontWeight: 700 }}>{manifests.reduce((a, m) => a + (palletCount(m, 'O') || 0), 0) || ''}</td>
                            <td style={{ ...s.td, textAlign: 'center', fontWeight: 700 }}>{manifests.reduce((a, m) => a + (Number(palletSpaces(m)) || 0), 0) || ''}</td>
                            <td style={s.td} colSpan={6}></td>
                        </tr>
                    </tfoot>
                </table>
            )}
        </div>
    );

    // ── Tracking view ────────────────────────────────────────────────────────
    const TrackingView = () => {
        const eventBadgeColour = (code) =>
            code === 'DELV' ? '#28a745' : code === 'POD' ? '#17a2b8' : code?.startsWith('ABR') ? '#dc3545' : '#6c757d';

        return (
            <div>
                {/* Header */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px', flexWrap: 'wrap' }}>
                    <h5 style={{ margin: 0 }}>Tracking</h5>
                    <input
                        type="date"
                        value={trackingDate}
                        onChange={e => setTrackingDate(e.target.value)}
                        style={s.input}
                    />
                    <button
                        style={{ ...s.btn('default'), fontSize: '12px' }}
                        onClick={async () => {
                            setIsSyncingTracking(true);
                            try {
                                const res = isPallettrack ? await syncPallettrack() : await syncPalletforceTracking(integrationId);
                                if (!res.ok) throw new Error(res.data?.error || `HTTP ${res.status}`);
                                alert({ message: `Tracking sync complete — ${res.data?.records_synced ?? 0} events updated`, type: 'success', buttons: [{ label: 'Close' }] });
                                loadTrackingForDate(trackingDate);
                            } catch (e) {
                                alert({ message: 'Sync failed: ' + e.message, type: 'danger', buttons: [{ label: 'Close' }] });
                            } finally {
                                setIsSyncingTracking(false);
                            }
                        }}
                        disabled={isSyncingTracking}
                    >
                        {isSyncingTracking ? 'Syncing…' : '↻ Sync Tracking'}
                    </button>
                    {/* Cross-date consignment search */}
                    <form
                        style={{ display: 'flex', gap: '6px' }}
                        onSubmit={e => { e.preventDefault(); const cn = cnSearchInput.trim().toUpperCase(); if (cn) setModalCn(cn); }}
                    >
                        <input
                            type="text"
                            placeholder="Search consignment…"
                            value={cnSearchInput}
                            onChange={e => setCnSearchInput(e.target.value.toUpperCase())}
                            style={{ ...s.input, width: '210px' }}
                        />
                        <button type="submit" style={{ ...s.btn('primary'), fontSize: '12px' }}>Search</button>
                    </form>
                    <span style={{ color: c.muted, fontSize: '12px' }}>
                        {isLoadingTracking ? 'Loading…' : `${consignmentRows.length} consignment${consignmentRows.length !== 1 ? 's' : ''}`}
                    </span>
                </div>

                {/* Consignment table — one row per consignment, latest event shown */}
                {isLoadingTracking ? (
                    <div style={{ textAlign: 'center', padding: '40px', color: c.muted }}>Loading events…</div>
                ) : consignmentRows.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '40px', color: c.muted }}>
                        No tracking events for {trackingDate}
                    </div>
                ) : (
                    <table style={s.table}>
                        <thead>
                            <tr>
                                {['Consignment No', 'Latest Event', 'Date / Time (local)', 'Signatory', 'Notes'].map(h => (
                                    <th key={h} style={s.th}>{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {consignmentRows.map((ev, i) => (
                                <tr
                                    key={ev.consignment_number}
                                    style={{ background: i % 2 === 0 ? 'transparent' : c.cardBg, cursor: 'pointer' }}
                                    onClick={() => setModalCn(ev.consignment_number)}
                                >
                                    <td style={{ ...s.td, color: '#1997eb', fontWeight: 600, textDecoration: 'underline' }}>
                                        {ev.consignment_number}
                                    </td>
                                    <td style={s.td}>
                                        <span style={s.badge(eventBadgeColour(ev.event_code))} title={EVENT_CODE_LABELS[ev.event_code] || ev.event_code}>
                                            {ev.event_code || '—'}
                                        </span>
                                    </td>
                                    <td style={s.td}>{fmtDTLocal(ev.event_datetime)}</td>
                                    <td style={s.td}>{ev.signatory || '—'}</td>
                                    <td style={s.td}>{ev.notes || '—'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        );
    };

    const CsvUploadView = () => {
        const upload = async () => {
            if (!csvFile) {
                alert({ message: 'Choose a CSV file first.', type: 'warning', buttons: [{ label: 'Close' }] });
                return;
            }
            setIsUploadingCsv(true);
            setCsvResult(null);
            try {
                const response = await importPallettrackCsv(csvFile);
                setCsvResult(response.data);
                const firstCreated = response.data?.created?.[0];
                const createdDate = firstCreated?.collection_date || firstCreated?.delivery_date;
                if (createdDate && firstCreated?.manifest_stored) {
                    setSelectedDate(createdDate);
                    setActiveView('manifests');
                }
                if (response.data?.validation_failed) return;
                if (!response.ok && response.status !== 207) {
                    throw new Error(response.data?.error || response.data?.errors?.[0]?.error || `HTTP ${response.status}`);
                }
            } catch (error) {
                alert({ message: `CSV upload failed: ${error.message}`, type: 'danger', buttons: [{ label: 'Close' }] });
            } finally {
                setIsUploadingCsv(false);
            }
        };

        return (
            <div style={{ maxWidth: '760px' }}>
                <h5 style={{ margin: '0 0 16px' }}>Upload Orders</h5>
                <div style={{ border: `1px solid ${c.border}`, background: c.cardBg, padding: '18px', borderRadius: '6px' }}>
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
                        <button style={s.btn('default')} onClick={() => downloadPallettrackCsvTemplate().catch(error => alert({ message: error.message, type: 'danger', buttons: [{ label: 'Close' }] }))}>
                            Download CSV Template
                        </button>
                        <button style={s.btn('default')} onClick={() => downloadPallettrackCsvGuide().catch(error => alert({ message: error.message, type: 'danger', buttons: [{ label: 'Close' }] }))}>
                            Download Field Guide (PDF)
                        </button>
                        <input
                            type="file"
                            accept=".csv,text/csv"
                            onChange={event => { setCsvFile(event.target.files?.[0] || null); setCsvResult(null); }}
                            style={s.input}
                        />
                        <button style={s.btn('primary')} onClick={upload} disabled={!csvFile || isUploadingCsv}>
                            {isUploadingCsv ? 'Uploading...' : 'Upload Orders'}
                        </button>
                    </div>
                </div>
                {csvResult && (
                    <div style={{ marginTop: '16px' }}>
                        {csvResult.validation_failed && (
                            <div style={{ color: '#dc3545', marginBottom: '10px', fontWeight: 600 }}>
                                Validation failed. No orders were sent to PalletTrack.
                            </div>
                        )}
                        <div style={{ marginBottom: '10px', fontWeight: 600 }}>
                            {csvResult.created?.length || 0} created, {csvResult.errors?.length || 0} failed
                        </div>
                        {(csvResult.created || []).map(item => (
                            <React.Fragment key={`created-${item.row}`}>
                                <div style={{ color: '#28a745', marginBottom: '5px' }}>
                                    Row {item.row}: created {item.consignment_number || item.tracking_code}
                                </div>
                                {(item.warnings || []).map((warning, index) => (
                                    <div key={`created-${item.row}-warning-${index}`} style={{ color: '#856404', marginBottom: '5px' }}>
                                        {warning}
                                    </div>
                                ))}
                            </React.Fragment>
                        ))}
                        {(csvResult.errors || []).map(item => (
                            <div key={`error-${item.row}`} style={{ color: '#dc3545', marginBottom: '5px' }}>
                                Row {item.row}: {item.error}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div style={s.wrap}>
            <div style={s.nav}>
                {[
                    { key: 'manifests', label: 'Manifests' },
                    { key: 'tracking',  label: 'Tracking' },
                    { key: 'kpis',      label: 'KPIs' },
                    ...(isPallettrack ? [{ key: 'csv', label: 'Upload CSV' }] : []),
                ].map(({ key, label }) => (
                    <div
                        key={key}
                        style={s.navItem(activeView === key)}
                        onClick={() => setActiveView(key)}
                    >
                        {label}
                    </div>
                ))}
            </div>
            <div style={s.content}>
                {activeView === 'manifests' && ManifestsView()}
                {activeView === 'tracking'  && TrackingView()}
                {activeView === 'kpis'      && <KpiTab theme={theme} showAlert={showAlert} integrationId={effectiveIntegrationId} />}
                {activeView === 'csv'       && CsvUploadView()}
            </div>

            {/* ── Consignment modal overlay ─────────────────────────────────── */}
            {modalCn && (() => {
                const pod     = podState[modalCn] ?? { images: [], loading: false };
                const mEntry  = expandedManifestData[modalCn] ?? { manifest: null, loading: false };
                const m       = mEntry.manifest;
                const evtBadge = (code) =>
                    code === 'DELV' ? '#28a745' : code === 'POD' ? '#17a2b8' : code?.startsWith('ABR') ? '#dc3545' : '#6c757d';

                // Vigo groups electronic signatures and scanned signed paperwork as POD.
                const sigImages = pod.images.filter(img =>
                    img.image_type === 'signature' || (isPallettrack && img.image_type === 'POD')
                );
                const delImages = pod.images.filter(img =>
                    isPallettrack ? img.image_type === 'DELIVERYPHOTO' : img.image_type !== 'signature'
                );

                const SectionHeading = ({ text }) => (
                    <div style={{ fontWeight: 700, fontSize: '12px', color: c.muted, textTransform: 'uppercase', letterSpacing: '0.6px', margin: '18px 0 8px' }}>
                        {text}
                    </div>
                );

                return (
                    <>
                        {/* Backdrop */}
                        <div
                            style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 1000 }}
                            onClick={() => setModalCn(null)}
                        />
                        {/* Panel */}
                        <div style={{
                            position: 'fixed', top: '5vh', left: '50%', transform: 'translateX(-50%)',
                            width: 'min(960px, 96vw)', maxHeight: '90vh',
                            background: c.bg, border: `1px solid ${c.border}`, borderRadius: '8px',
                            display: 'flex', flexDirection: 'column', zIndex: 1001, overflow: 'hidden',
                        }}>
                            {/* Modal header */}
                            <div style={{ background: c.headerBg, padding: '12px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
                                <span style={{ fontWeight: 700, fontSize: '15px' }}>Consignment: {modalCn}</span>
                                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                    {isPallettrack && <>
                                        <input
                                            ref={paperworkInputRef}
                                            type="file"
                                            accept="application/pdf,image/jpeg,image/png,image/tiff"
                                            onChange={handleUploadPaperwork}
                                            style={{ display: 'none' }}
                                        />
                                        <button
                                            style={{ ...s.btn('default'), fontSize: '12px' }}
                                            onClick={() => paperworkInputRef.current?.click()}
                                            disabled={isUploadingPaperwork}
                                            title="Upload PDF, JPEG, PNG or TIFF paperwork to PalletTrack"
                                        >
                                            {isUploadingPaperwork ? 'Uploading…' : 'Upload Paperwork'}
                                        </button>
                                        <button
                                            style={{ ...s.btn('default'), fontSize: '12px' }}
                                            onClick={() => handleLoadPallettrackMedia(modalCn)}
                                            disabled={pod.loading}
                                            title="Check Vigo for POD, signatures and delivery photographs"
                                        >
                                            {pod.loading ? 'Checking Media…' : 'Refresh Delivery Media'}
                                        </button>
                                    </>}
                                    {!isPallettrack && <button
                                        style={{ ...s.btn('default'), fontSize: '12px' }}
                                        onClick={() => handleRefreshPod(modalCn)}
                                        disabled={pod.loading}
                                        title="Search DB then Palletforce for images"
                                    >
                                        📷 {pod.loading ? 'Loading…' : '↻ Reload Images'}
                                    </button>}
                                    {!isPallettrack && <button
                                        style={{ ...s.btn('default'), fontSize: '12px' }}
                                        onClick={() => handleCheckPaperwork(modalCn)}
                                        disabled={paperworkState[modalCn]?.loading}
                                        title="Check DB then Palletforce for customer paperwork"
                                    >
                                        📄 {paperworkState[modalCn]?.loading ? 'Checking…' : 'Check Paperwork'}
                                    </button>}
                                    <button style={{ ...s.btn('danger'), fontSize: '12px' }} onClick={() => setModalCn(null)}>
                                        ✕ Close
                                    </button>
                                </div>
                            </div>

                            {/* Scrollable body */}
                            <div style={{ overflowY: 'auto', padding: '16px 20px', flex: 1 }}>

                                {/* ── Consignment details ── */}
                                <SectionHeading text="Consignment Details" />
                                {mEntry.loading ? (
                                    <div style={{ color: c.muted, fontSize: '13px' }}>Loading…</div>
                                ) : m ? (
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px,1fr))', gap: '5px 24px', fontSize: '13px' }}>
                                        <DetailRow label="Customer Reference" value={m.customer_reference} />
                                        <DetailRow label="Service"            value={m.service_code} />
                                        <DetailRow label="Collection Date"    value={fmtDate(m.collection_date)} />
                                        <DetailRow label="Delivery Date"      value={fmtDate(m.delivery_date)} />
                                        {fmtBookingTime(m.booking_time_from, m.booking_time_to, m.raw_data) && (
                                            <DetailRow label="Booking Window" value={fmtBookingTime(m.booking_time_from, m.booking_time_to, m.raw_data)} />
                                        )}
                                        <DetailRow label="Synced"             value={fmtDTLocal(m.synced_at)} />
                                        <DetailRow label="Full (F)"           value={palletCount(m, 'F') || null} />
                                        <DetailRow label="Half (H)"           value={palletCount(m, 'H') || null} />
                                        <DetailRow label="Quarter (Q)"        value={palletCount(m, 'Q') || null} />
                                        <DetailRow label="Oversize (O)"       value={palletCount(m, 'O') || null} />
                                        <DetailRow label="Pallet Spaces"      value={palletSpaces(m)} />
                                        <DetailRow label="Weight"             value={m.weight ? `${m.weight} kg` : null} />
                                        <DetailRow label="Delivery Depot"     value={m.delivery_depot || m.raw_data?.deliveryDepot} />
                                        {(m.surcharges || m.raw_data?.surcharges) && (
                                            <div style={{ marginBottom: '4px' }}>
                                                <span style={s.label}>Surcharges:</span>
                                                {(m.surcharges || m.raw_data.surcharges).split(' ').filter(Boolean).map(code => (
                                                    <span key={code} title={surchargeLabels[code] || code} style={{ ...s.badge(getSurchargeColour(code)), marginRight: '3px' }}>{code}</span>
                                                ))}
                                            </div>
                                        )}
                                        <div style={{ gridColumn: '1/-1', borderTop: `1px solid ${c.border}`, paddingTop: '6px', marginTop: '4px', fontWeight: 600, fontSize: '12px', color: c.muted, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                            Delivery Address
                                        </div>
                                        <DetailRow label="Name"     value={m.delivery_name} />
                                        <DetailRow label="Address"  value={[m.delivery_address1, m.delivery_address2].filter(Boolean).join(', ')} />
                                        <DetailRow label="City"     value={m.delivery_town} />
                                        <DetailRow label="Postcode" value={m.delivery_postcode} />
                                        {m.special_instructions && (
                                            <div style={{ gridColumn: '1/-1', marginBottom: '4px' }}>
                                                <span style={s.label}>Special Instructions:</span>
                                                <span style={{ color: '#ffc107' }}>{m.special_instructions}</span>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div style={{ color: c.muted, fontSize: '13px' }}>No manifest data found for this consignment.</div>
                                )}

                                {/* ── All events ── */}
                                <SectionHeading text={`Events${modalEvents.length ? ` (${modalEvents.length})` : ''}`} />
                                {isLoadingModalEvents ? (
                                    <div style={{ color: c.muted, fontSize: '13px' }}>Loading events…</div>
                                ) : modalEvents.length === 0 ? (
                                    <div style={{ color: c.muted, fontSize: '13px' }}>No events found.</div>
                                ) : (
                                    <table style={{ ...s.table, fontSize: '12px' }}>
                                        <thead>
                                            <tr>
                                                {['Pallet ID', 'Date / Time (local)', 'Event', 'Signatory', 'Notes'].map(h => (
                                                    <th key={h} style={s.th}>{h}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {modalEvents.map((ev, i) => (
                                                <tr key={ev.id ?? i} style={{ background: i % 2 === 0 ? 'transparent' : c.cardBg }}>
                                                    <td style={s.td}>{ev.pallet_id || '—'}</td>
                                                    <td style={s.td}>{fmtDTLocal(ev.event_datetime)}</td>
                                                    <td style={s.td}>
                                                        <span style={s.badge(evtBadge(ev.event_code))} title={EVENT_CODE_LABELS[ev.event_code] || ev.event_code}>{ev.event_code || '—'}</span>
                                                    </td>
                                                    <td style={s.td}>{ev.signatory || '—'}</td>
                                                    <td style={s.td}>{ev.notes || '—'}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}

                                {/* ── Signatures ── */}
                                <SectionHeading text={isPallettrack ? "POD / Signatures" : "Signatures"} />
                                {pod.loading ? (
                                    <div style={{ color: c.muted, fontSize: '13px' }}>Loading…</div>
                                ) : sigImages.length > 0 ? (
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
                                        {sigImages.map((img, idx) => (
                                            <div key={img.id ?? idx} style={{ border: `1px solid ${c.border}`, borderRadius: '6px', overflow: 'hidden', background: c.cardBg }}>
                                                {img.signed_url ? (
                                                    img.mime_type?.startsWith('image/') && img.mime_type !== 'image/tiff' ? (
                                                        <a href={img.signed_url} target="_blank" rel="noopener noreferrer">
                                                            <img src={img.signed_url} alt={`POD ${idx + 1}`}
                                                                style={{ maxWidth: '200px', maxHeight: '140px', display: 'block', objectFit: 'contain' }}
                                                                onError={e => { e.target.style.display = 'none'; }} />
                                                        </a>
                                                    ) : (
                                                        <a href={img.signed_url} target="_blank" rel="noopener noreferrer" style={{ display: 'block', padding: '16px', color: '#0d6efd' }}>
                                                            Open {img.mime_type === 'application/pdf' ? 'signed POD PDF' : 'POD file'}
                                                        </a>
                                                    )
                                                ) : (
                                                    <div style={{ padding: '16px', color: c.muted, fontSize: '12px' }}>{img.storage_path}</div>
                                                )}
                                                <div style={{ padding: '4px 8px', fontSize: '11px', color: c.muted }}>
                                                    {isPallettrack ? 'POD / Signature' : 'Signature'} · {img.downloaded_at ? img.downloaded_at.slice(0, 10) : ''}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div style={{ color: c.muted, fontSize: '13px' }}>{isPallettrack ? 'No POD or signature media found.' : 'No signature images stored.'}</div>
                                )}

                                {/* ── Delivery images ── */}
                                <SectionHeading text="Delivery Images" />
                                {pod.loading ? (
                                    <div style={{ color: c.muted, fontSize: '13px' }}>Loading…</div>
                                ) : delImages.length > 0 ? (
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
                                        {delImages.map((img, idx) => (
                                            <div key={img.id ?? idx} style={{ border: `1px solid ${c.border}`, borderRadius: '6px', overflow: 'hidden', background: c.cardBg }}>
                                                {img.signed_url ? (
                                                    <a href={img.signed_url} target="_blank" rel="noopener noreferrer">
                                                        <img src={img.signed_url} alt={`Delivery ${idx + 1}`}
                                                            style={{ maxWidth: '260px', maxHeight: '200px', display: 'block', objectFit: 'contain' }}
                                                            onError={e => { e.target.style.display = 'none'; }} />
                                                    </a>
                                                ) : (
                                                    <div style={{ padding: '20px', color: c.muted, fontSize: '12px' }}>{img.storage_path}</div>
                                                )}
                                                <div style={{ padding: '4px 8px', fontSize: '11px', color: c.muted }}>
                                                    {img.image_type || 'Delivery'} · {img.downloaded_at ? img.downloaded_at.slice(0, 10) : ''}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <>
                                        <div style={{ color: c.muted, fontSize: '13px' }}>No delivery images stored.</div>
                                        {pod.fetchErrors && pod.fetchErrors.length > 0 && (
                                            <div style={{ marginTop: '6px', padding: '8px 12px', background: '#fff3cd', border: '1px solid #ffc107', borderRadius: '4px', fontSize: '12px', color: '#856404' }}>
                                                <strong>{isPallettrack ? 'PalletTrack response:' : 'Palletforce response:'}</strong>
                                                {pod.fetchErrors.map((e, i) => <div key={i}>{e}</div>)}
                                            </div>
                                        )}
                                    </>
                                )}

                                {/* ── Customer Paperwork ── */}
                                {(() => {
                                    const pw = paperworkState[modalCn];
                                    if (!pw) return null;
                                    const TYPE_LABEL = {
                                        D: 'Delivery Depot',
                                        R: 'Requesting Depot',
                                        CUSTOMERPAPERWORK: 'Customer Paperwork',
                                    };
                                    return (
                                        <>
                                            <SectionHeading text={`Customer Paperwork${pw.items?.length ? ` (${pw.items.length})` : ''}`} />
                                            {pw.loading ? (
                                                <div style={{ color: c.muted, fontSize: '13px' }}>Checking…</div>
                                            ) : pw.items?.length > 0 ? (
                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                                    {pw.items.map((item, i) => (
                                                        <div key={i} style={{ border: `1px solid ${c.border}`, borderRadius: '6px', padding: '8px 12px', background: c.cardBg, fontSize: '12px', display: 'flex', flexDirection: 'column', gap: '4px', minWidth: '140px' }}>
                                                            <div style={{ fontWeight: 600 }}>{TYPE_LABEL[item.paperwork_type] || item.paperwork_type}</div>
                                                            {item.filename && <div>{item.filename}</div>}
                                                            <div style={{ color: c.muted }}>{item.mime_type}</div>
                                                            {item.signed_url ? (
                                                                item.mime_type === 'application/pdf' ? (
                                                                    <a href={item.signed_url} target="_blank" rel="noreferrer" style={{ color: '#0d6efd', textDecoration: 'underline', wordBreak: 'break-all' }}>
                                                                        📄 Open PDF
                                                                    </a>
                                                                ) : item.mime_type?.startsWith('image/') && item.mime_type !== 'image/tiff' ? (
                                                                    <a href={item.signed_url} target="_blank" rel="noreferrer">
                                                                        <img src={item.signed_url} alt={`Paperwork ${i + 1}`} style={{ maxWidth: '160px', maxHeight: '120px', borderRadius: '4px', objectFit: 'contain', display: 'block' }} />
                                                                    </a>
                                                                ) : (
                                                                    <a href={item.signed_url} target="_blank" rel="noreferrer" style={{ color: '#0d6efd', textDecoration: 'underline', wordBreak: 'break-all' }}>
                                                                        Open file
                                                                    </a>
                                                                )
                                                            ) : (
                                                                <span style={{ color: c.muted }}>URL unavailable</span>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div style={{ color: c.muted, fontSize: '13px' }}>No paperwork found.</div>
                                            )}
                                        </>
                                    );
                                })()}

                            </div>
                        </div>
                    </>
                );
            })()}
        </div>
    );
}
